module.exports = __webpack_public_path__ + "img/user-130.7f17548.png";